import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentSelectMaterials from './ContentSelectMaterials';

const SelectMaterials = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentSelectMaterials />
      <Bottom />
    </div>
  );
};

export default SelectMaterials;
